/**
 * Exports constant types for Authentication related processes.
 */

export const LOGIN = "LOGIN"
export const AUTH_ERROR = "AUTH_ERROR"
export const LOGGEDIN = "LOGGEDIN"